/**
 * Retorna o primeiro segmento de um campo agregado pelo índice de busca do
 * InsureMO, que concatena valores de todos os `PolicyCustomer` por `\n`
 * (estipulante + subestipulantes). Usado para exibir o estipulante nas
 * listagens — ex.: `Nome`, `CPF`/CNPJ. Para uma policy com 1 customer,
 * retorna o próprio valor.
 */
export function firstNameSegment(value?: string | null): string {
  if (!value) return '';
  const [first] = value
    .split('\n')
    .map(part => part.trim())
    .filter(Boolean);
  return first ?? '';
}
